import "../Backgrounds.css";
import "./About.css";
import MainHeader from "../components/MainHeader";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import { useEffect } from "react";

const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="aboutMeBackground">
      <MainHeader />

      <div className="mainContentWrapper">
        <div className="aboutMeContentWrapper">
          <div className="solidLine"></div>

          <div className="aboutMeContent">
            <img
              src="/Will Behind Piano.jpg"
              className="headshot"
              alt="Will Turner at the piano"
            />
            <div className="aboutMeText">
              <p>
                Will Turner is an award-winning, Bristol-based composer working
                primarily in Film, TV, and Games. His scores have premiered at
                Cannes, Aesthetica, Visions du Réel, Jackson Wild, and
                Wildscreen, with broadcast work airing on Channel 4, BBC Two,
                Disney+, National Geographic, Roku, and Hulu. He is currently
                working on a landmark six-part natural history documentary
                series, set to air on BBC One in 2026.
              </p>
              <br></br>
              <p>
                With a focus on innovative storytelling, Will moved to Bristol
                with the goal of contributing to the city’s thriving wildlife
                filmmaking scene. Over the past six years, he has composed the
                scores for 15 wildlife projects, including Life On The
                Rocks—which beat Perfect Planet to win ‘Best in Festival’ at the
                International Wildlife Film Festival in 2021. Since then, he has
                written the scores for six broadcast series, including the 6 x
                1-hour BBC NHU series Big Cats 24/7, which aired in the prime
                Sunday 8pm slot on BBC Two and has since been recommissioned for
                two further series. His work culminates in a forthcoming 5npm x
                1-hour landmark natural history documentary series, set to air
                on BBC One in 2026.
              </p>
              <br></br>
              <p>
                Alongside natural history, Will has worked across genres,
                contributing to over 40 other projects. These include a
                Grierson-nominated documentary, work airing on Channel 4,
                adaptive video game scoring projects, and a TV drama pilot
                currently in production.
              </p>
              <br></br>
              <p>
                Will graduated with a Master’s in Composition from the National
                Film and Television School in 2019, where he received the
                Christie Prize for the most promising student. He has also been
                awarded the Francis Chagrin Award for innovation in composition.
              </p>
              <br></br>
              <p>
                Originally a classically trained pianist and saxophonist, Will
                developed a strong foundation in traditional form and
                orchestration—skills that have proved invaluable throughout his
                scoring career. After spending several years in various punk,
                rock, and electronic bands, he expanded his musical vocabulary
                and honed his production skills, enabling him to incorporate a
                contemporary sound into his work. This combination offers an
                alternative, modern approach to scoring that runs through much
                of his portfolio.
              </p>
              <br></br>
              <p>
                As a film composer what Will privileges above all else is
                collaboration and of course - story.
              </p>
              <br></br>
              <div className="portfolioClickThroughContainer">
                <Link to="/portfolio">
                  <button className="button4">FULL PORTFOLIO</button>
                </Link>
              </div>
            </div>
          </div>

          <div className="solidLine"></div>

          <Footer />
        </div>
      </div>
    </div>
  );
};
export default About;
